import Vue from 'vue'
import { onGlobalSetup, useContext } from '@nuxtjs/composition-api'
import useUserAuthorization from '~/services/userAuthorization'

export default () => {
  onGlobalSetup(() => {
    const ctx = useContext()
    Vue.prototype.$userAuthorization = useUserAuthorization(ctx)
  })
}
